module.exports = "<div layout=\"column\" layout-align=\"space-between stretch\" ng-cloak>\n    <md-button class=\"md-raised md-accent text-notransform\"\n               ng-repeat=\"aspect in $ctrl.aspects\"\n               ng-class=\"$ctrl.isCurrentAspect($index) ? 'md-hue-1' : 'md-hue-2' \"\n               ui-sref=\"mini.learningEngagement.aspect({aspectNr: $index})\"\n               flex=\"100\">\n        {{aspect.name}}\n    </md-button>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/evaluation/pages/stepLearningEngagement/aspectsMenu/aspectsMenuView.html
// module id = 283
// module chunks = 0